import React, { useEffect, useState } from 'react'
import { Table } from '../styles'
import { NameInitials } from '../../Manager/styles'
import { GetUsersListForFlaggedPost } from '../../../redux/constants/apiConstants';
import PropTypes from 'prop-types';
import { fetchApi, getInitials } from '../../../utils/methods';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import { withTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { ImageUrl } from '../../../utils/constants';

const FlaggedUsers = ({postDetails, userCompanyId}) => {

  const [flaggedUsers, setFlaggedUsers] = useState(postDetails?.flagged_by || []);
  const[pageNumber, setPageNumber] = useState(1);
  const[paginationData, setPaginationData] = useState(null);
  const[loading, setLoading] = useState(false);

  useEffect(()=>{
    setFlaggedUsers(postDetails?.flagged_by);
    getUsersListForFlaggedPostDetails(1);
  },[]);

  const getUsersListForFlaggedPostDetails = async (page) => {
    setLoading(true);
    setPageNumber(page)
    
    let apiUrl = `${GetUsersListForFlaggedPost}/${userCompanyId}/${postDetails?.id}/${page}/20`;
    try {
      const res = await fetchApi(apiUrl, "GET");
      if (res.status === "success") {
        setLoading(false);
        setPaginationData(res.data.pagination);
        if(page != 1){
          setFlaggedUsers([...flaggedUsers,...res.data.users])
        }

        // setUserFlagDetails(res)
      } else {
        toast.error(res.data.message);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    } 
  };

  return (
    <>
      <div style={{ width: '50%' }}>
        <Table padding="8px 0" insight>
          <div className="heading">This post has been flagged by</div>
          <div className="type">
            <div className="name">Employees</div>
            <div className="value">Reasons</div>
          </div>
          <div style={{height:"325px",overflowY:"auto"}}>
            {flaggedUsers?.map((item, Index) => (
              <div className="item" key={Index}>
                {item.profile_image && item.profile_image != "profile-Image/default.png" ? (
                  <div className="profile">
                    <img src={`${ImageUrl}/${item.profile_image}`} alt={item.name} />
                  </div>
                ) : (
                  <NameInitials style={{marginRight:"8px"}}>{getInitials(item.flagged_by)}</NameInitials>
                )}
                <div className="name">{item.flagged_by}</div>
                <div className="value">{item.reason}</div>
              </div>
            ))}
          </div>
          {pageNumber + 1 <= paginationData?.total_pages ? (
            <div className="showmore">
              <div className="button" onClick={() => !loading && getUsersListForFlaggedPostDetails(pageNumber+1)}>Show More</div>
            </div>
          ):null}
        </Table>
      </div>
    </>
  )
}

FlaggedUsers.propTypes = {
  postDetails: PropTypes.object,
  userCompanyId:PropTypes.number
}

const mapStateToProps = (state) => ({
  userCompanyId: state.profileData.companyDetails.id,
})
export default connect(mapStateToProps, null)(withRouter(withTranslation()(FlaggedUsers)));